import { render, staticRenderFns } from "./main_menu_item.vue?vue&type=template&id=f24ceaae&scoped=true&"
import script from "./main_menu_item.vue?vue&type=script&lang=js&"
export * from "./main_menu_item.vue?vue&type=script&lang=js&"
import style0 from "./main_menu_item.vue?vue&type=style&index=0&id=f24ceaae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24ceaae",
  null
  
)

export default component.exports